export type AppThemeName = 'light' | 'lightWhiteMenu' | 'dark';

export interface IThemeOption {
  name: AppThemeName;
  label: string;
  swatch: string;
}

export const THEME_OPTIONS: IThemeOption[] = [
  { name: 'light', label: 'Claro (menu escuro)', swatch: '#0B1524' },
  { name: 'lightWhiteMenu', label: 'Claro (menu claro)', swatch: '#f3f4f6' },
  { name: 'dark', label: 'Escuro', swatch: '#1e3a5f' },
];

// Cor dos ícones/avatar/checkbox na tela de login.
export const LOGIN_ACCENT: Record<AppThemeName, string> = {
  light: '#0284c7',
  lightWhiteMenu: '#0284c7',
  dark: '#1e3a5f',
};

// Cor do botão "Entrar" na tela de login (tom levemente diferente do acento acima).
export const LOGIN_BUTTON_ACCENT: Record<AppThemeName, { bg: string; hover: string }> = {
  light: { bg: '#0EA5E9', hover: '#0369A1' },
  lightWhiteMenu: { bg: '#0EA5E9', hover: '#0369A1' },
  dark: { bg: 'rgba(255, 255, 255, 0.25)', hover: 'rgba(255, 255, 255, 0.35)' },
};
